<template>
  <v-app id="adminApp">
    <header-item />

    <v-content>
      <v-container>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            align="center"
          >
            <h2>ログイン</h2>
          </v-col>
        </v-row>
        <v-card
          class="mx-auto mt-5"
          color="lighten-3"
          max-width="600px"
        >
          <v-container>
            <v-row align="center">
              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
              >
                <v-text-field
                  v-model="userId"
                  required
                  prepend-icon="mdi-account-circle"
                  label="ユーザーID"
                  placeholder=" "
                  maxlength="48"
                />
              </v-col>
              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
              >
                <v-text-field
                  v-model="pass"
                  required
                  type="password"
                  prepend-icon="mdi-lock"
                  label="パスワード"
                  placeholder=" "
                  maxlength="256"
                />
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
                align="center"
              >
                <v-btn
                  color="primary"
                  :loading="loading"
                  :disabled="loading"
                  @click="Login();"
                >
                  ログイン
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>

        <v-card
          class="mx-auto mt-5"
          color="lighten-3"
          max-width="600px"
          flat
        >
          <v-row
            align="center"
            dense
          >
            <v-col
              class="mr-0"
              cols="12"
              sm="12"
              md="12"
              align="right"
            >
              <v-card-text>
                ユーザーID/パスワード忘れの場合は
                <a
                  id="forgetUserDialog"
                  href="#forgetUserDialog"
                  style="color:blue;"
                  tabindex="0"
                  @click="forgetUserDialog = true;"
                >
                  <u>こちら</u>
                </a>
              </v-card-text>
            </v-col>
            <!--
            <v-col
              class="mr-0"
              cols="12"
              sm="12"
              md="12"
              align="right"
            >
              <v-card-text class="pb-2">
                初回登録は
                <router-link
                  to="AdminCreate"
                  style="color:blue"
                >
                  こちら
                </router-link>
              </v-card-text>
              <v-card-text class="pt-0">
                <span v-if="$vuetify.breakpoint && $vuetify.breakpoint.xs">※初回登録にはWeplatデータ共有サービス<br>
                  スターターライセンス(有償)が必要です
                </span>
                <span v-else>※初回登録にはWeplatデータ共有サービス スターターライセンス(有償)が必要です</span>
              </v-card-text>
            </v-col>
            -->
          </v-row>
        </v-card>
      </v-container>
    </v-content>

    <!-- ↓↓パスワード案内ダイアログ -->
    <v-dialog
      v-model="forgetUserDialog"
      width="700"
    >
      <v-card>
        <v-container>
          <v-card-title class="pa-0">
            <v-spacer />
            <v-btn
              icon
              large
              color="#3F51B5"
              @click="forgetUserDialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-row align="center">
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-card-text>ユーザーID忘れの場合：</v-card-text>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <a
                href="https://faq.r4support.epson.jp/app/answers/detail/a_id/4357#q1"
                style="font-size:20px"
                target="_blank"
                rel="noopener"
              >
                FAQへ
              </a>
              <v-icon
                color="primary"
                dense
              >
                mdi-open-in-new
              </v-icon>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-card-text>パスワード忘れの場合：</v-card-text>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-btn
                color="primary"
                @click="resetPassDialog = true;"
              >
                パスワードリセットへ
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-card-text>ユーザーID/パスワードともに不明な場合：</v-card-text>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <a
                href="https://faq.r4support.epson.jp/app/answers/detail/a_id/4358#q1"
                style="font-size:20px"
                target="_blank"
                rel="noopener"
              >
                FAQへ
              </a>
              <v-icon
                color="primary"
                dense
              >
                mdi-open-in-new
              </v-icon>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- ↑↑パスワード案内ダイアログ -->

    <!-- ↓↓パスワードリセットダイアログ -->
    <v-dialog
      v-model="resetPassDialog"
      width="400"
      persistent
    >
      <v-card>
        <v-card-title primary-title>
          パスワードリセット
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="closeResetPassDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          パスワードをリセットしたいユーザーID、メールアドレスを入力してください。
          事前に登録された情報と一致する場合、メールアドレスにパスワードリセットを行う画面へのリンクを送信します。
        </v-card-text>
        <v-container>
          <v-col
            cols="12"
            sm="12"
            md="12"
          >
            <v-form
              ref="resetPassForm"
              v-model="valid"
              lazy-validation
              @submit.prevent
            >
              <v-text-field
                v-model="resetPassUserId"
                label="ユーザーID(※)"
                required
                counter="48"
                maxlength="48"
                :rules="[v => !!v || &quot;ユーザーIDは必須です&quot;]"
              />
              <v-text-field
                v-model="resetPassMail"
                style="white-space:pre-line; word-wrap:break-word;"
                label="メールアドレス(※)"
                required
                counter="256"
                maxlength="256"
                :rules="[v => !!v || 'メールアドレスは必須です',
                         v => /[^\s]+@[^\s]+/.test(v) || 'メールアドレスが正しくありません']"
                hint="「no-reply@wd.weplat.epson.jp」からメールが届きます。受信先で迷惑メールフィルタを設定している場合には、このメールアドレスの受信を許可してください。"
              />
            </v-form>
          </v-col>
        </v-container>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            :loading="loadingResetPassword"
            :disabled="loadingResetPassword"
            @click="resetPassword"
          >
            確定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ↑↑パスワードリセットダイアログ -->
    <msg-dlg ref="MsgDlg" />
  </v-app>
</template>

<script>

import HeaderItem from './HeaderItem.vue'
import AppConfig from '../app_config.json';
import Amplify, {RestApiUtil} from '../amplify_com.js';
import MsgDlg from './MsgDlg.vue'

export default {
  components: {
    'header-item': HeaderItem,
    'msg-dlg': MsgDlg,
  },
  data: () => ({
    valid: null,
    loading: false,
    loadingResetPassword: false,
    pass: "",
    userId: "",
    onetimePass: "",
    mfaflg: false,
    forgetUserDialog: false,
    resetPassDialog: false,
    header_env: AppConfig.header_env,
    resetPassUserId: "",
    resetPassMail: "",
  }),  
  beforeCreate: function () {
    // キーチェック
    let _this = this;
    if(_this.$route && _this.$route.query.key){
      let key = _this.$route.query.key;
      // 処理中にする
      setTimeout(() => {
        _this.loading = true;
        _this.$refs.MsgDlg.showInfo('処理中です。');
      }, 1);
      // キーチェックrestAPIを実施。
      RestApiUtil.PostMailTokenAuth(key).then(mailTokenAuth => {
        // 次の遷移先urlを取得できたなら遷移
        if(mailTokenAuth.next_url){
          var next_path = mailTokenAuth.next_url;
          setTimeout(() => (_this.$router.push({ path: next_path }, () => {}, () => {})), 2000);
        }
      }).catch(() => {
        _this.loading = false;
      });
    } else {
      Amplify.Auth.currentUserPoolUser().then(user => {
        var user_name = user.username;
        if(user.attributes.preferred_username){
          user_name = user.attributes.preferred_username;
        } 
        _this.$refs.MsgDlg.showInfo('ブラウザに保存されている情報から' + user_name + '様でログインします。');
        _this.loading = true;
        setTimeout(() => (_this.$router.push({ path: "Top" }, () => {}, () => {})), 2000);
      }).catch(() => {
        _this.loading = false;
      });
    }
  },
  methods: {
    Login : async function() {
        if(!this.userId){
          this.$refs.MsgDlg.showError('ユーザーIDを入力してください');
          return;
        }
        if(!this.pass){
          this.$refs.MsgDlg.showError('パスワードを入力してください');
          return;
        }

        let _app = this;
        _app.loading = true;
        await Amplify.Auth.signIn(
          {
            username : _app.userId,
            password : _app.pass,
            validationData: {
              input_username: _app.userId,
            },
          }
        ).then(user => {
          // MFAチェック
          let _user = user;
          if(_user['challengeName'] === 'SOFTWARE_TOKEN_MFA'){
            _app.$refs.MsgDlg.showOkCancel(null, 'ワンタイムパスワードを入力してください', 'onetimepass')
            .then(function(ret) {
              if(ret.okCancelResult){
                Amplify.Auth.confirmSignIn(
                    _user,
                    ret.onetimepass,
                    'SOFTWARE_TOKEN_MFA'
                ).then(() => {
                  _app.$refs.MsgDlg.showSuccess('ワンタイムパスワード認証に成功しました。');
                  // 次へ
                  setTimeout(() => (_app.$router.push({ path: "Top" }, () => {}, () => {})), 2000);
                }).catch(err => {
                  _app.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(err));
                  _app.loading = false;
                });
              }else{
                _app.loading = false;
              }
            }).catch(err => {
              _app.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(err));
              _app.loading = false;
            });
          } else {
            // 次へ
            setTimeout(() => (_app.$router.push({ path: "Top" }, () => {}, () => {})), 2000);
          }
        }).catch(err => {
          _app.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(err));
          _app.loading = false;
        });
    },
    //パスワードリセット
    resetPassword : async function(){
      //バリデーション
      if(!this.$refs.resetPassForm.validate()){
        return;
      }
      //ボタン無効化
      this.loadingResetPassword = true;
      // API呼び出し
      let forgotUserId = null;
      await RestApiUtil.PostPasswordReset(this.resetPassUserId, this.resetPassMail).then(passwordReset => {
        forgotUserId = passwordReset.user_id;
      }).catch(() => {
        forgotUserId = null;
        this.loadingResetPassword = false;
      });

      if(!forgotUserId){
        this.$refs.MsgDlg.showError("正しいユーザーID、メールアドレスを入力してください。");
        this.loadingResetPassword = false;
        return;
      }

      // 確認メールを送信 送信に多少時間がかかるのでこの段階で送信しておく
      let result = false;
      await Amplify.Auth.forgotPassword(
          forgotUserId,
      ).then(() => {
        result = true;
      }).catch(err => {
        this.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(err));
        this.loadingResetPassword = false;
        result = false;
      });

      if(!result){
        this.loadingResetPassword = false;
        return;
      }

      // ダイアログを閉じる
      this.closeResetPassDialog();
      this.$refs.MsgDlg.showSuccess('メールアドレスへパスワードリセット画面へのリンクを送付しました。');
    },
    closeResetPassDialog(){
      this.resetPassDialog = false;
      this.$refs.resetPassForm.reset();
      this.loadingResetPassword = false;
    }
  },
};
</script>